exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".btn.btn-primary.pull-right[data-v-0fa54306]{margin-right:15px}\n", ""]);

